
//import {db, functions} from "@/scripts/firebase";
import { ClassData } from "@/common-datatypes";
import { Component,Mixins,Watch } from "vue-property-decorator"
import {where,query,getDocs} from 'firebase/firestore'
import { ValidationObserver } from 'vee-validate'
import Common from '@/mixins/common'

@Component

export default class ClassList extends Mixins(Common) {
  classes: ClassData[] = []
  classesProps = {} as {[key: string]: {hidden: boolean}}
  isLoading = false
  orderBy: keyof ClassData = 'creationTime'

  get observer(){
    return this.$refs.classListSearchFormValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  search = ''

  searchResult = ''

  searchResultsNum = 0
  
  @Watch('search')
  changeSearchText(val: string){
    let searchResultsNum = 0
    this.classes.forEach((cl) => {
      if(cl.classId){
        if(val.length === 0){
          this.$set(this.classesProps, cl.classId , {hidden: false})
          return
        }

        if((cl.name && cl.name.indexOf(val) > -1) || (cl.description && cl.description.indexOf(val) > -1) || Object.values(cl.memberMeta).some((member) => {return this.$findTextByUserProfile(val,member)})){
          this.$set(this.classesProps, cl.classId , {hidden: false})
          searchResultsNum ++
          return
        }

          this.$set(this.classesProps, cl.classId , {hidden: true})
      }
    })

    if(val && searchResultsNum === 0){
      this.searchResult = this.$t('groupList.notFound') as string
    }else{
      this.searchResult = ''
    }
    this.searchResultsNum = searchResultsNum
  }

  async created(){
    console.trace('created')

    this.$store.commit("setLoading",true);
    this.isLoading = true
      
    try{
      const classesRef = await getDocs(query(this.$getClassesColRef(),where('deleted','==',false)))
      this.classes = classesRef.docs.map( (doc) => {
        const row = doc.data() as ClassData
        return {classId: doc.id,...row}
      });
      console.log(this.classes)
    }catch(error){
      console.log(error)
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }
 
  destroyed() {
    console.trace('destroyed');
  }

}
